export default __webpack_public_path__ + "static/media/AEREA.c0d1f5af.jpg";